export default __webpack_public_path__ + "static/media/ImageWaterMark.c5edba40.svg";